import { useEffect, useRef } from "react";
import { onMessage } from "firebase/messaging";
import { messaging } from "../../../firebase";
import displayNotification from "../../../utils/displayNotification";
import { useNavigate } from "react-router-dom";

function NotificationHandler() {
  const notificationHandled = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleForegroundNotification = (payload) => {
      if (!payload.notification || notificationHandled.current) return;

      // Evitar notificaciones duplicadas
      notificationHandled.current = true;

      displayNotification(payload, navigate);

      // Restaurar el estado después de un breve tiempo
      setTimeout(() => {
        notificationHandled.current = false;
      }, 1000);
    };

    // Inicializar el listener para las notificaciones en primer plano
    const unsubscribe = onMessage(messaging, (payload) => {
      handleForegroundNotification(payload);
    });

    const swMessageHandler = (event) => {
      const payload = event.data;
      handleForegroundNotification(payload);
    };

    // navigator.serviceWorker no existe en contextos no seguros o algunos modos privados
    const hasServiceWorker = "serviceWorker" in navigator;
    if (hasServiceWorker) {
      navigator.serviceWorker.addEventListener("message", swMessageHandler);
    }

    // Limpiar el listener cuando el componente se desmonte
    return () => {
      if (unsubscribe && typeof unsubscribe === "function") {
        unsubscribe();
      }
      if (hasServiceWorker) {
        navigator.serviceWorker.removeEventListener("message", swMessageHandler);
      }
    };
  }, [navigate]);

  return null;
}

export default NotificationHandler;
